import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import "../../pages/mondoub pages/home-page/components/transaction-contributions/contribution.css";
import { BsClock, BsTruck } from 'react-icons/bs';
import { TiTick } from 'react-icons/ti';
import { BiError } from 'react-icons/bi';
import { useFetchData } from '../../hooks/useFetchData';

function OrdersChart() {
  const { data, loading, error } = useFetchData("mandoub/stats?scope=orders");
  const [chartData, setChartData] = useState({
    series: [
      { name: 'تم التوصيل', data: [] },
      { name: 'معلق', data: [] },
      { name: 'ملغي', data: [] }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        width: "100%", // Assurez-vous que le graphique prend toute la largeur
        stacked: true,
        toolbar: {
          tools: {
            download: false
          }
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [{
        breakpoint: 768,
        options: {
          chart: {
            width: '100%',
          },
          plotOptions: {
            bar: {
              horizontal: true, // Ajustement automatique pour les petits écrans
            }
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'around',
          borderRadiusWhenStacked: 'last end',
        },
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px',
            colors: ['#000'],
          }
        }
      },
      fill: {
        opacity: 1
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['#ffffff']
      },
      dataLabels: {
        enabled: false,
        total: {
          enabled: false
        }
      },
      legend: {
        show: false
      },
      colors: ['var(--shipped-light)', 'var(--pending-light)', 'var(--error-light)']
    }
  });

  const [totals, setTotals] = useState({
    delivered: 0,
    pending: 0,
    canceled: 0,
    total: 0
  });

  useEffect(() => {
    if (data?.success && data?.orders) {
      // Group orders by year
      const ordersByYear = data.orders.reduce((acc, order) => {
        const year = new Date(order.orderDate).getFullYear();
        if (!acc[year]) {
          acc[year] = {
            delivered: 0,
            pending: 0,
            canceled: 0
          };
        }
        
        switch (order.status) {
          case 'Delivered':
            acc[year].delivered++;
            break;
          case 'Pending':
            acc[year].pending++;
            break;
          case 'Canceled':
            acc[year].canceled++;
            break;
        }
        return acc;
      }, {});

      // Sort years and prepare chart data
      const years = Object.keys(ordersByYear).sort();
      const deliveredData = years.map(year => ordersByYear[year].delivered);
      const pendingData = years.map(year => ordersByYear[year].pending);
      const canceledData = years.map(year => ordersByYear[year].canceled);

      // Calculate totals
      const totalDelivered = data.orders.filter(order => order.status === 'Delivered').length;
      const totalPending = data.orders.filter(order => order.status === 'Pending').length;
      const totalCanceled = data.orders.filter(order => order.status === 'Canceled').length;

      setTotals({
        delivered: totalDelivered,
        pending: totalPending,
        canceled: totalCanceled,
        total: data.orders.length
      });

      // Update chart data
      setChartData(prev => ({
        ...prev,
        series: [
          { name: 'تم التوصيل', data: deliveredData },
          { name: 'معلق', data: pendingData },
          { name: 'ملغي', data: canceledData }
        ],
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: years
          }
        }
      }));
    }
  }, [data]);

  if (loading) return <div>Loading...</div>;
  if (error){ 
    <>
    <div>{error}</div>
   <div>Error loading data</div>;
    </>
  }

  


  return (
    <div className='section-card flex1 !w-1/2 sm-w-full' style={{ borderRadius: "1rem" }} dir='rtl'>
      <div dir='rtl' className='df-c'>
        <div className="title">الطلبات</div>
        <div className="df-c !g2">
          <div className="df w-full">
            <div className="df !gap-2 w-1/2">
              <div className="rounded-icon !w-10 !h-10 !rounded-md">
                <BsTruck />
              </div>
              <div className="df-c g0">
                <div className='text-black font-bold'>{totals.delivered}</div>
                <div className='text'>إجمالي التوصيل</div>
              </div>
            </div>
            <div className="df">
              <div className="rounded-icon yellowed !w-10 !h-10 !rounded-md">
                <BsClock />
              </div>
              <div className="df-c g0">
                <div className='text-black font-bold'>{totals.pending}</div>
                <div className='text'>إجمالي معلق</div>
              </div>
            </div>
          </div>
          <div className="df w-full">
            <div className="df !gap-2 w-1/2">
              <div className="rounded-icon pinked !w-10 !h-10 !rounded-md">
                <TiTick />
              </div>
              <div className="df-c g0">
                <div className='text-black font-bold'>{totals.total}</div>
                <div className='text'>إجمالي الطلبات</div>
              </div>
            </div>
            <div className="df">
              <div className="rounded-icon errored !w-10 !h-10 !rounded-md">
                <BiError />
              </div>
              <div className="df-c g0">
                <div className='text-black font-bold'>{totals.canceled}</div>
                <div className='text'>إجمالي الملغي</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='chart2' className='w-full df-c ai-center'>
        <ReactApexChart 
          type='bar' 
          height={200} 
          width="100%" // Ajout de width="100%" pour éviter le dépassement
          style={{ width: "100%" }} 
          series={chartData.series} 
          options={chartData.options} 
        />
      </div>
    </div>
  );
}

export default OrdersChart;